import {
    alertManager,
    signalingManager,
} from '@/utils/audioHandler'
import {
    mapMutations,
    mapGetters,
} from 'vuex'
import isLogged from '@/helpers/api/isLogged'

const socket = {
    data() {
        return {
            alert: alertManager,
            signaling: signalingManager,
        }
    },
    computed: {
        ...mapGetters({
            userCallGetters: 'userCallGetters',
            adminTalking: 'adminTalkingGetters',
        }),
    },
    methods: {
        ...mapMutations({
            setShowNotification: 'setShowNotification',
            setSocketDialogId: 'setSocketDialogId',
            setIsliveUpdate: 'setIsliveUpdate',
        }),
        isSendNotifications(value) {
            if (this.$store.state.admin.data.notification_settings[value]) {
                return true
            }
        },
    },
    mounted() {
    /* MESSAGES START */
        this.$options.sockets['messages.admin.clients:message.created'] = (
            data,
        ) => {
            this.$store.dispatch('soketMessage', data)
        }
        this.$options.sockets['messages.admin.clients:message.changed'] = (
            data,
        ) => {
            this.$store.dispatch('changeMessage', data)
        }
        this.$options.sockets['messages.admin.clients:message.deleted'] = (
            data,
        ) => {
            this.$store.dispatch('deleteLocalMessage', data)
        }
        this.$options.sockets['messages.admin.masters:message.created'] = (
            data,
        ) => {
            this.$store.dispatch('soketMessage', data)
        }
        this.$options.sockets['messages.admin.masters:message.changed'] = (
            data,
        ) => {
            this.$store.dispatch('changeMessage', data)
        }
        this.$options.sockets['messages.admin.masters:message.deleted'] = (
            data,
        ) => {
            this.$store.dispatch('deleteLocalMessage', data)
        }
        this.$options.sockets['messages.admin.engineers:message.created'] = (
            data,
        ) => {
            this.$store.dispatch('soketMessage', data)
        }
        this.$options.sockets['messages.admin.engineers:message.changed'] = (
            data,
        ) => {
            this.$store.dispatch('changeMessage', data)
        }
        this.$options.sockets['messages.admin.engineers:message.deleted'] = (
            data,
        ) => {
            this.$store.dispatch('deleteLocalMessage', data)
        }
        /* MESSAGES END */

        /* CALL START */

        this.$options.sockets['calls.admin:call.incoming'] = (data) => {
            if (!isLogged()) return

            const user = {
                fullName: data.name,
                photo: data.image,
                session_id: data.session_id,
                type: data.type,
                answer: true,
                isAudioCall: true,
            }

            this.$store.state.calls.currentCall = data.session_id
            if (this.$store.state.calls.show === false) {
                this.$store.dispatch('showCallModal', user)
            }
        }

        this.$socket.on('admin.notifications:call.incoming', (data) => {
            if (this.$store.state.admin.data.id === data.admin_id) {
                this.$store.commit('setTalkdeskCaller', data)
                this.$store.commit('setTalkdesk', true)
            }
        })

        this.$options.sockets['calls.admin:call.canceled'] = (data) => {
            if (!isLogged()) return

            if (
                this.$store.state.calls.show === true
        && this.$store.state.calls.currentCall === data.session_id
            ) {
                this.$store.state.calls.currentCall = ''
                this.$store.dispatch('hideCallModal')
            }
        }

        this.$socket.on('calls.admin:call.missed', (data) => {
            if (!isLogged()) return

            if (localStorage.getItem('missedId') === data.contact_id) {
                return
            }

            localStorage.setItem('missedId', data.contact_id)

            const res = {
                client_id: data.contact_id,
                dialog_type: 'clients',
                name: data.full_name,
                image: null,
                is_new: true,
                type: 'missed_call',
                datetime: 1586935848,
                socket: null,
            }

            this.setShowNotification(true)
            this.alert.play()
            this.$store.dispatch('addNotification', res)
            setTimeout(() => {
                localStorage.setItem('missedId', null)
            }, 500)
        })

        this.$socket.on('calls.admin:call.answered', () => {
            if (!isLogged()) return

            if (!this.adminTalking) {
                this.$store.dispatch('hideCallModal')
            }
        })

        /* CALL END */

        /* NOTIFICATION START */
        this.$socket.on('admin.notifications:master.not-shift', (data) => {
            if (!isLogged()) return

            this.setShowNotification(true)
            this.$store.dispatch('addNotification', data)
        })

        this.$socket.on('admin.notifications:request.canceled', (data) => {
            if (!isLogged()) return

            this.setShowNotification(true)
            this.$store.dispatch('addNotification', data)
        })

        this.$socket.on('admin.notifications:request.updated', () => {
            if (!isLogged() || this.$route.name !== 'orders') return

            this.$store.dispatch('orders/fetchWithSavingScrollState')
        })

        this.$socket.on('admin.notifications:client.new', (data) => {
            if (!isLogged()) return

            if (this.isSendNotifications('clients')) {
                this.setShowNotification(true)
                this.alert.play()
                this.$store.dispatch('addNotification', data)
                this.$store.dispatch('fetchNewClientsCount')
            }
        })

        this.$socket.on('admin.notifications:request.new', (data) => {
            if (!isLogged()) return

            if (this.isSendNotifications('requests')) {
                this.setShowNotification(true)
                this.$store.commit('setUpdateCalendar')
                this.$store.dispatch('orders/fetchNewOrdersCount')
                this.$store.dispatch('orders/fetchWithSavingScrollState')

                this.signaling.play()
                setTimeout(() => {
                    this.signaling.reset()
                }, 57000)

                this.$store.dispatch('addNotification', data)
            }
        })

        this.$socket.on('admin.notifications:message.new', (data) => {
            if (!isLogged()) return

            if (this.isSendNotifications('messages')) {
                if (data.client_id !== undefined) {
                    this.setSocketDialogId(data.client_id)
                } else if (data.master_id !== undefined) {
                    this.setSocketDialogId(data.master_id)
                }

                this.setIsliveUpdate(true)
                this.setShowNotification(true)

                this.alert.play()

                this.$store.dispatch('addNotification', data)
            }
        })
    /* NOTIFICATION END */
    },
}

export default socket
